module.exports = __webpack_public_path__ + "img/ico-trash.6ba6185d.svg";